import { createAction } from "@reduxjs/toolkit";

export const LOADING_START = "LOADING_START";
export const LOADING_STOP = "LOADING_STOP";
export const SEARCHBAR_MODAL_OPEN = "SEARCHBAR_MODAL_OPEN";
export const SEARCHBAR_MODAL_CLOSE = "SEARCHBAR_MODAL_CLOSE";
export const SEARCHBAR_MODAL_CLEAR_INSTANCE = "SEARCHBAR_MODAL_CLEAR_INSTANCE";

export type ISearchBarModalPayload = {
    instanceId: string;
    modalKey: string;
};

export const startLoading = createAction(LOADING_START);
export const stopLoading = createAction(LOADING_STOP);
export const openSearchBarModal =
    createAction<ISearchBarModalPayload>(SEARCHBAR_MODAL_OPEN);
export const closeSearchBarModal = createAction<ISearchBarModalPayload>(
    SEARCHBAR_MODAL_CLOSE
);
export const clearSearchBarModalInstance = createAction<{ instanceId: string }>(
    SEARCHBAR_MODAL_CLEAR_INSTANCE
);

export const setIsLoading = (isLoading: boolean) =>
    isLoading ? startLoading() : stopLoading();
